var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8e8e98;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #363c4f;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6,
    y: 9,
    width: 20,
    height: 20,
    rx: 3.03,
    ry: 3.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.97,29.5H9.03c-1.95,0-3.53-1.58-3.53-3.53V12.04c0-1.95,1.59-3.53,3.53-3.53h13.93c1.95,0,3.53,1.58,3.53,3.53v13.93c0,1.95-1.59,3.53-3.53,3.53ZM9.03,9.5c-1.4,0-2.53,1.14-2.53,2.53v13.93c0,1.4,1.14,2.53,2.53,2.53h13.93c1.4,0,2.53-1.14,2.53-2.53V12.04c0-1.4-1.14-2.53-2.53-2.53H9.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,22.86v-1c1.58,0,2.86-1.28,2.86-2.86s-1.28-2.86-2.86-2.86v-1c2.13,0,3.86,1.73,3.86,3.86s-1.73,3.86-3.86,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.64,9h-1c0-.9-.74-1.64-1.64-1.64s-1.64,.74-1.64,1.64h-1c0-1.46,1.18-2.64,2.64-2.64s2.64,1.18,2.64,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,22.86c-2.13,0-3.86-1.73-3.86-3.86s1.73-3.86,3.86-3.86v1c-1.58,0-2.86,1.28-2.86,2.86s1.28,2.86,2.86,2.86v1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 11.73,
    cy: 19,
    r: 2.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.73,22.1c-1.71,0-3.09-1.39-3.09-3.09s1.39-3.09,3.09-3.09,3.09,1.39,3.09,3.09-1.39,3.09-3.09,3.09Zm0-5.19c-1.15,0-2.09,.94-2.09,2.09s.94,2.09,2.09,2.09,2.09-.94,2.09-2.09-.94-2.09-2.09-2.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 20.27,
    cy: 19,
    r: 2.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.27,22.1c-1.71,0-3.09-1.39-3.09-3.09s1.39-3.09,3.09-3.09,3.09,1.39,3.09,3.09-1.39,3.09-3.09,3.09Zm0-5.19c-1.15,0-2.09,.94-2.09,2.09s.94,2.09,2.09,2.09,2.09-.94,2.09-2.09-.94-2.09-2.09-2.09Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 3.86,
    width: 1,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,4.36c-.92,0-1.67-.75-1.67-1.67s.75-1.67,1.67-1.67,1.67,.75,1.67,1.67-.75,1.67-1.67,1.67Zm0-2.34c-.37,0-.67,.3-.67,.67s.3,.67,.67,.67,.67-.3,.67-.67-.3-.67-.67-.67Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchie);
export default __webpack_public_path__ + "static/media/Archie.0b86fca9953568a73f68b47d26b1e92b.svg";
export { ForwardRef as ReactComponent };